/**
 * Websocket re-connect timeout
 */
export const DefaultConnectTimeout = 2000;